/* eslint-disable comma-dangle */
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import theme from '@quiqupltd/qu-react-sdk/lib/styles/theme';
import * as Sentry from '@sentry/browser';

import App from './app/App';
import './styles/main.scss';
import getEnvVars from './configEnv';
import environment from './environment';
import { version } from '../package.json';

getEnvVars().then(vars => {
  window.env = { ...vars };

  if (window.env.SITE_ENV === environment.production) {
    Sentry.init({
      dsn: window.env.SENTRY_DSN,
      environment: window.env.SITE_ENV,
      release: `trackapp@${version}`,
    });
  }

  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>,
    document.getElementById('root')
  );
});



// WEBPACK FOOTER //
// ./src/index.js